const state = {
  pageCacheList: []
};
const getters = {
  getPageCacheList: state => {
    return state.pageCacheList;
  }
};
const mutations = {
  ADD(state, pageName) {
    state.pageCacheList.push(pageName);
  },
  DEL(state, pageName) {
    state.pageCacheList.forEach((page, index) => {
      if (page === pageName) {
        state.pageCacheList.splice(index);
      }
    });
  }
};
const actions = {
  add({ commit }, pageName) {
    commit("ADD", pageName);
  },
  delete({ commit }, pageName) {
    commit("DEL", pageName);
  }
};

const pageCache = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
export default pageCache